module.exports = __webpack_public_path__ + "static/hoxnox-944013efe441e8103544c72b0f8d03b0.png";